import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";
import "./_index.scss";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
} from "@mui/material";
import LoadingImage from "components/LoadingImage";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import config from "utils/config";

const ResetPasswordForm = (props) => {
  const {
    formik,
    submitError,
    setSubmitError,
    handleSwitchToLogin,
    successMessage,
  } = props;
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };
  
  return (
    <>
      <div className="auth-header">
        <img
          src={require("assets/login_illustration.svg").default}
          alt="logo"
          className="auth-header-illustration"
          style={{
            height: config.auth_popup.login_modal.header.illustrationHeight,
          }}
        />
        <div className="auth-header-title">
          {t("we-are-happy-nto-see-you-again")}{" "}
        </div>
        <p className="auth-header-subtitle">
          {t(
            "continue-to-improve-your-skills-faster-with-simplified-nand-straight-to-the-point-labs-created-for-you",
          )}{" "}
        </p>
      </div>
      <div className="auth-form-container">
        <div
          style={{
            height: "fit-content",
          }}
          className="auth-form"
        >
          <div className="auth-form-forgot-password">
            <Grid container>
              <Grid item xs={12}>
                <p className="auth-form-forgot-password-title">
                  {t("new-password")}{" "}
                </p>
              </Grid>
              <Grid item xs={12}>
                <p className="auth-form-forgot-password-subtitle">
                  {t(
                    "please-create-a-new-password-that-you-dont-nuse-on-any-other-site",
                  )}{" "}
                </p>
              </Grid>
              <Grid item xs={12} style={{ margin: "24px 0 0 0" }}>
                <TextField
                  fullWidth
                  id="code"
                  name="code"
                  label={t("verification-code")}
                  InputProps={{ sx: { borderRadius: "8px" } }}
                  value={formik.values.code}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.code && Boolean(formik.errors.code)}
                  helperText={formik.touched.code && formik.errors.code}
                />
              </Grid>
              <Grid item xs={12} style={{ margin: "24px 0" }}>
                <TextField
                  fullWidth
                  name="password"
                  label={t("password")}
                  type={showPassword ? "text" : "password"}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                  InputProps={{
                    sx: { borderRadius: "8px" },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={t("toggle-password-visibility")}
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} style={{ margin: "0 0 24px 0" }}>
                <TextField
                  fullWidth
                  name="confirmPassword"
                  label={t("confirm-new-password")}
                  type={showConfirmPassword ? "text" : "password"}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.confirmPassword &&
                    Boolean(formik.errors.confirmPassword)
                  }
                  helperText={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  InputProps={{
                    sx: { borderRadius: "8px" },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={t("toggle-password-visibility")}
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} style={{ display: "flex" }}>
                {formik.isSubmitting ? (
                  <LoadingImage></LoadingImage>
                ) : (
                  <FormControl fullWidth>
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        setSubmitError("");
                        formik.handleSubmit();
                      }}
                      disableElevation
                      disableFocusRipple
                      disableRipple
                      disableTouchRipple
                      className="auth-form-confirm-btn hover:!bg-blue-dark"
                      variant="contained"
                    >
                      {t("confirm-new-password")}{" "}
                    </Button>
                    <FormHelperText>{submitError}</FormHelperText>
                    <FormHelperText style={{ color: "#10B981" }}>
                      {successMessage}
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                <p className="auth-form-forgot-password-go-to-signup">
                  {t("just-remember")}{" "}
                  <Link onClick={handleSwitchToLogin}>{t("sign-in")}</Link>
                </p>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordForm;
